import { CompanyShowType as ApiCompanyShowType } from 'src/api/generated/touring/types';
import { mapLinkableEntityType, mapShowWithTourType } from '../common';
import { CompanyShowType } from './types';

export const mapCompanyShow = (apiCompanyShow: ApiCompanyShowType): CompanyShowType => {
  const showWithTour = mapShowWithTourType(apiCompanyShow.showWithTour);

  return {
    showWithTour,
    showDate: showWithTour.showDate,
    dealType: apiCompanyShow.dealType ?? null,
    production: apiCompanyShow.production ?? null,
    agent: apiCompanyShow.agent ? mapLinkableEntityType(apiCompanyShow.agent) : null,
    tourLead: apiCompanyShow.tourLead
      ? mapLinkableEntityType(apiCompanyShow.tourLead)
      : null,
    tourCoPro: apiCompanyShow.tourCoPro
      ? mapLinkableEntityType(apiCompanyShow.tourCoPro)
      : null,
    coPro: apiCompanyShow.coPro ? mapLinkableEntityType(apiCompanyShow.coPro) : null,
    status: apiCompanyShow.status,
  };
};
